export const AD_PREVIEW_TYPES = [
  'MOBILE_FEED_STANDARD',
  'DESKTOP_FEED_STANDARD',
  'FACEBOOK_STORY_MOBILE',
  'INSTAGRAM_STANDARD',
  'INSTAGRAM_STORY',
];
